import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ToastrService } from 'ngx-toastr';
import { ApisService } from '../../services/apis.service';

@Component({
  selector: 'app-jockey-comments',
  templateUrl: './jockey-comments.component.html',
  styleUrls: ['./jockey-comments.component.scss']
})

export class JockeyCommentsComponent implements OnInit {

  @Input() jockey;
  meta: {
    saving: boolean
  };
  disableReadScale = false;
  userId: number;
  noteTypes: Array<any>;
  jockeyComment: {
    edited: boolean,
    textCode: number,
    comment: string
  };

  constructor(
    public activeModal: NgbActiveModal,
    private apiService: ApisService,
    private notification: ToastrService
  ) { }

  ngOnInit() {
    // console.log('[ DEBUG ] Data received:', this.jockey);
    this.meta = {
      saving: false
    };
    this.noteTypes = this.apiService.getCommentTypes();
    this.jockeyComment = {
      textCode: 0,
      comment: '',
      edited: false
    };

    this.apiService.observableLoggedIn.subscribe(data => {
      this.userId = data.user_id;
    });
  }

  loadComment(textCode) {
    console.log(this.jockey.comments, textCode);
    textCode = Number(textCode);
    const existingComment = this.jockey.comments.find(comment => comment.textCode === textCode);
    this.jockeyComment.comment = existingComment ? existingComment.comment : null;
    this.jockeyComment.textCode = textCode;
    this.jockeyComment.edited = false;
  }

  confirm() {
    this.meta.saving = true;
    const payload = {
      animalId: this.jockey.animalId,
      jockeyId: this.jockey.jockeyId,
      yearOfRace: this.jockey.yearOfRace,
      raceId: this.jockey.raceId,
      divisionSequence: this.jockey.divisionSequence,
      comment: this.jockeyComment.comment,
      textCode: Number(this.jockeyComment.textCode),
      updatedBy: this.userId
    };

    this.apiService.updateRunnerComments(payload.yearOfRace, payload.raceId, payload.divisionSequence, payload.animalId, payload)
      .subscribe(
        res => {
          // console.log('[ DEBUG ] Jockey Data Saved:', res);
          this.activeModal.close(payload);
          this.notification.success(`${this.jockey.jockeyName} comments has been saved.`, 'Jockey Comment');
        },
        err => {
          console.error('[ DEBUG ] Error updating Jockey', err);
          this.notification.error(`Could't save the notes. Check your connection and Try again.`, 'Jockey Comment');
          this.meta.saving = false;
        }
      );
  }

  cancel(action) {
    this.activeModal.dismiss(action);
  }
}
